// extracted by mini-css-extract-plugin
module.exports = {"container":"e_9x","pending":"e_-x","slider":"e_ay","imageContainer":"e_by","image":"e_cy","button":"e_dy","prevButton":"e_ey","nextButton":"e_fy","disabled":"e_gy"};